import { namespace } from 'vuex-class';

export const user = namespace('user');
export const layout = namespace('layout');
export const loader = namespace('loader');
export const tickets = namespace('tickets');
export const feedbacks = namespace('feedbacks');
export const bills = namespace('bills');
export const maintenanceReports = namespace('maintenanceReports');
export const ticketsDashboard = namespace('ticketsDashboard');
export const contacts = namespace('contacts');
export const customerManagement = namespace('customerManagement');
export const reportsDashboard = namespace('reports/reportsDashboard');
export const reportsManagement = namespace('reports/reportsManagement');
export const equipments = namespace('equipments');
